import { render, staticRenderFns } from "./BannerTable.vue?vue&type=template&id=621f9079"
import script from "./BannerTable.vue?vue&type=script&lang=ts"
export * from "./BannerTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports